import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../share/util/api/polling';

/** DID変換前のデータ */
const DID = '$DID$';

/**
 * API通信共通処理
 * @param {object} self 呼び出し元インスタンス
 * @param {string} type リクエストのtype
 * @param {async () => {}} completedCallback status: completed のときのコールバック関数
 * @param {async () => {}} failedCallback status: failed のときのコールバック関数
 */
export async function executeApi(self, type, completedCallback,
  failedCallback = async (self) => { self.showUnexpectedError(); }
) {
  try {
    self.isLoading = true;
    const token = session.getToken();
    // データ読み出し(要求)（バックエンドAPI_POST）
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: type,
      },
      //  エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      (errorType) => { errorType; self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
    );

    if (!response) return;

    // type: read_with_session_transition の場合のみ、NonDefaultSession遷移の結果を保持しておく
    if (type === 'read_with_session_transition') {
      self.sessionTransitionFlag = Boolean(response.data?.user_data?.session_transition_flag);
    }

    switch (response.data.status) {
      // 正常終了
      case REQUEST_STATUS_COMPLETED:
        await completedCallback(self, response);
        break;
      // 異常終了
      case REQUEST_STATUS_FAILED:
        await failedCallback(self);
        break;
      default:
        self.showUnexpectedError();
        break;
    }
  } finally {
    self.isLoading = false;
  }
}

/**
 * res_typeを確認する場合のstatus === 'completed' 時共通処理
 * @param {object} self 呼び出し元インスタンス
 * @param {object} response APIレスポンス
 * @param {async () => {}} okResultCallback result: ok のときのコールバック関数
 * @param {async () => {}} ngResultCallback result: ng のときのコールバック関数
 */
export async function handleResponseType(self, response, okResultCallback, ngResultCallback) {
  switch (response.data.user_data.res_type) {
    case 'ok':
      await okResultCallback(self);
      break;
    case 'ng':
    default:
      await ngResultCallback(self);
      break;
  }
}

/**
 * wheel_rotation_ratioを確認する場合のstatus === 'completed' 時共通処理
 * @param {object} self 呼び出し元インスタンス
 * @param {object} response APIレスポンス
 * @param {string} key i18nのキー
 * @param {async () => {}} completedCallback status: completed のときのコールバック関数
 */
export async function handleRatio(self, response, key, completedCallback) {
  // DIDデータフォーマット用共通関数使用のために整形
  const didItems = {
    readout_data: response.data.user_data.wheel_rotation_ratio
  };
  const readOutData = await individualWorkSupportUtil.getReadOutData(self, self.systemId, didItems);
  // フォーマット後の return (前後輪回転比:[数値]-\n) から数値のみ取り出して文言内の$DID$を置換
  self.replaceMessage = readOutData.split(':')[1];
  self.ratioInfo = self.$t(`${self.i18nWsKey}.${key}`).replace(DID, self.replaceMessage);
  await completedCallback(self);
}

